function setUpSingleCarouselDirective() {
  const language = $('html').attr('lang');
  const rtlBool = language === 'ar';

  $('.js-directive-single-slide').each((i, item) => {
      const $item = $(item);
      const $carousel = $item.find('.js-directive-carousel');
      $carousel.slick({
          lazyLoad: 'anticipated',
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: $item.find('.js-prev'),
          nextArrow: $item.find('.js-next'),
          rtl: rtlBool,
          touchThreshold: 20,
      });
  });
}

$(function() {
  setUpSingleCarouselDirective();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/directives.js